import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import { TailSpin } from 'react-loader-spinner';
import { forgetPasswordService } from '../functions/forgotPassword';
import PinInput from 'react-pin-input';

const ForgotPassword = () => {
    
    const [stage, setStage] = useState(1);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [Err, setErr] = useState(false);
    const [message, setMessage] = useState('');
    const [note, setNote] = useState('');
    const [token, setToken] = useState('');
    const navigate = useNavigate();

    const [userID, setUserID] = useState('');
    const [email, setEmail] = useState('');
    const ForgetPasswordSchema1 = Yup.object().shape({
        email: Yup.string().email().required("Email is required"),
    });

    const submitForm1 = (values) => {
        // console.log(values.email);

        setEmail(values.email);
        setLoading1(true);
        setErr(false);

        forgetPasswordService.checkEmail(values)
            .then((response) => {
                console.log(response);
                let res = response.body;
                if(res.isValid) {
                    setUserID(res.individualID)
                    setStage(2);
                    setLoading1(false);
                } else {
                    setMessage('Email not found. Please try again.');
                    setErr(true);
                    setLoading1(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setMessage('Ops... Something went wrong. Please try again later.');
                setErr(true);
                setLoading1(false);
            });
    };

    const pinStyleCss = {
        padding : '10px'
    }
    const pinInputStyleCss = {
        borderColor : '#777',
        borderRadius : '8px',
        borderWidth : '1px',
        backgroundColor : 'rgba(57,56,62,0.75)',
        color : '#bbb'
    }
    const pinInputFocusStyleCss = {
        borderColor : 'royalblue',
        borderRadius : '8px',
        borderWidth : '2px',
        color : '#bbb'
    }

    const pinOnComplete = (value, index) => {
        setErr(false);
        setLoading2(true);

        forgetPasswordService.verifyOTP(userID, value)
            .then((response) => {
                // console.log(response);
                if(response.status) {
                    setToken(response.token);
                    setStage(3);
                    setLoading2(false);
                } else {
                    setMessage('Ops... Something went wrong. Please try again later.');
                    setErr(true);
                    setLoading2(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setMessage('Ops... Something went wrong. Please try again later.');
                setErr(true);
                setLoading2(false);
            });
    }

    const resendOTP = () => {
        setErr(false);
        setLoading2(true);

        forgetPasswordService.resendOTP('', email)
            .then((response) => {
                // console.log(response);
                if(response.status) {
                    setNote('New OTP has been sent to your email successfully.');
                    setLoading2(false);
                } else {
                    setLoading2(false);
                    setMessage('Ops... Something went wrong. Please try again later.');
                    setErr(true);
                }
            })
            .catch((err) => {
                console.log(err);
                setMessage('Ops... Something went wrong. Please try again later.');
                setErr(true);
                setLoading2(false);
            });
    }

    const initialValues3 = {
        password1 : '',
        password2 : ''
    }
    const ForgetPasswordSchema3 = Yup.object().shape({
        password1: Yup.string()
            .required("Password is required")
            .min(8, "Password is too short - should be 8 chars minimum"),

        password2: Yup.string()
            .required("Password is required")
            .oneOf([Yup.ref('password1'), null], 'Passwords must match')
    });
    const submitForm3 = (values) => {
        setErr(false);
        setLoading3(true);

        forgetPasswordService.resetPassword(userID, values.password1, values.password2, token)
            .then((response) => {
                console.log(response);
                if(response.status) {
                    setNote('Your password has been updated successfully. You will be redirected shortly.');
                    setLoading3(false);
                    setTimeout(function() { navigate('/Login'); }, 5000);
                } else {
                    setMessage('Invalid Pin. Please try again.');
                    setErr(true);
                    setLoading3(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setMessage('Invalid Pin. Please try again.');
                setErr(true);
                setLoading3(false);
            });
    }

    return (
        <Container fluid="lg" className='wrapper'>
            <Row className="RegisterMemberRow">

                <h1>Forgot Password</h1>

                {Err && (
                    <Col md={12} xs={12}>
                        <Alert variant="danger" onClose={() => setErr(false)} dismissible>
                            {message}
                        </Alert>
                    </Col>
                )}
                {note!='' && (
                    <Col md={12} xs={12}>
                        <Alert variant="success" onClose={() => setNote('')} dismissible>
                            {note}
                        </Alert>
                    </Col>
                )}

                {stage==1 && (
                    <>
                        <Col xs={12} md={6} className="section left-divider">
                                
                            <Formik
                                initialValues={{email : email}}
                                validationSchema={ForgetPasswordSchema1}
                                onSubmit={submitForm1}
                            >
                                {({
                                    values,
                                    handleChange,
                                    handleSubmit,
                                    errors,
                                    touched,
                                    handleBlur,
                                    isValid,
                                    dirty
                                }) => (
                            
                                    <Form noValidate onSubmit={handleSubmit}>
        
                                        <Row className="mb-3">
                                            <p>Please enter your email to check your sign up status.</p>
                                        </Row>
        
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom01">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="email"
                                                    type="email"
                                                    placeholder="abc@gmail.com"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    isValid={touched.email && !errors.email}
                                                    isInvalid={!!errors.email}
                                                    
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
        
                                        <Row className="p-3">
                                            <Button type="submit" size="lg" className="red-button  d-flex justify-content-center">
                                                Check &nbsp;
                                                <TailSpin
                                                    height="30"
                                                    width="30"
                                                    color="#ccc"
                                                    ariaLabel="tail-spin-loading1"
                                                    radius="1"
                                                    wrapperStyle={{}}
                                                    wrapperClass="loader"
                                                    visible={loading1}
                                                />
                                            </Button>
                                        </Row>
        
                                    </Form>
        
                                )}
                            </Formik>
        
                        </Col>
        
                        <Col xs={12} md={6} className="section">
                            <div className="loginButtonSection">
                                <Row>
                                    <img src={`${process.env.PUBLIC_URL}/images/register1.png`} alt=""  />
                                </Row>
                            </div>
                        </Col>
                    </>
                )}

                {stage==2 && (
                    <>
                        <Col xs={12} md={6} className="section left-divider">
                            <Row>
                                <img src={`${process.env.PUBLIC_URL}/images/otp.png`} alt="" id="otp-logo" />
                            </Row>
                        </Col>
        
                        <Col xs={12} md={6} className="text-center pin-section p-3">
                            
                            <p className="mb-5 mt-5">
                                One time pin (OTP) has been sent to your email. Please key-in the pin in the fields provided below to verify your identity.
                            </p>

                            <h4>{email}</h4>

                            <br />

                            <TailSpin
                                height="50"
                                width="50"
                                color="#fff"
                                ariaLabel="tail-spin-loading"
                                radius="1"
                                wrapperStyle={{margin: "0.5rem auto"}}
                                wrapperClass="loader"
                                visible={loading2}
                            />

                            <PinInput 
                                length={6} 
                                initialValue=""
                                // secret 
                                focus
                                onChange={(value, index) => {}} 
                                type="numeric" 
                                inputMode="number"
                                style={pinStyleCss}  
                                inputStyle={pinInputStyleCss}
                                inputFocusStyle={pinInputFocusStyleCss}
                                onComplete={pinOnComplete}
                                autoSelect={true}
                                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                            />
            
                            <a className="mt-3" onClick={resendOTP}>Resend OTP</a>
                                        
                        </Col>
                    </>
                )}

                {stage==3 && (
                    <>
                        <Col xs={12} md={6} className="section left-divider">
                                
                            <Formik
                                initialValues={initialValues3}
                                validationSchema={ForgetPasswordSchema3}
                                onSubmit={submitForm3}
                            >
                                {({
                                    values,
                                    handleChange,
                                    handleSubmit,
                                    errors,
                                    touched,
                                    handleBlur,
                                    isValid,
                                    dirty
                                }) => (
                            
                                    <Form noValidate onSubmit={handleSubmit}>
        
                                        <Row className="mb-3">
                                            <p>Please enter your new password</p>
                                        </Row>
        
                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Password</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="password1"
                                                    type="password"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.password1}
                                                    isValid={touched.password1 && !errors.password1}
                                                    isInvalid={!!errors.password1}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.password1}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" controlId="validationCustom02">
                                                <Form.Label>Confirm Password</Form.Label>
                                                <Form.Control
                                                    required
                                                    name="password2"
                                                    type="password"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.password2}
                                                    isValid={touched.password2 && !errors.password2}
                                                    isInvalid={!!errors.password2}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.password2}</Form.Control.Feedback>
                                            </Form.Group>
                                        </Row>
        
                                        <Row className="p-3">
                                            <Button type="submit" size="lg" className="red-button  d-flex justify-content-center">
                                                Reset &nbsp;
                                                <TailSpin
                                                    height="30"
                                                    width="30"
                                                    color="#ccc"
                                                    ariaLabel="tail-spin-loading1"
                                                    radius="1"
                                                    wrapperStyle={{}}
                                                    wrapperClass="loader"
                                                    visible={loading3}
                                                />
                                            </Button>
                                        </Row>
        
                                    </Form>
        
                                )}
                            </Formik>
        
                        </Col>

                        <Col xs={12} md={6} className="section">
                            <div className="loginButtonSection">
                                <Row>
                                    <img src={`${process.env.PUBLIC_URL}/images/password.png`} alt=""  />
                                </Row>
                            </div>
                        </Col>
                    </>
                )}
            
            </Row>
        </Container>
    );
}

export default ForgotPassword;